import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { PairChallenge } from 'src/app/views/select-challenge/components/select-challenges-container/challenges-sub-challenges/challenges-sub-challenges.model';
import { DiagnosisSolutionCompatibility } from '../../common/models/workflow/diagnosis-solution';
import { setAllRequiredCheckboxesSelected } from '../../store/actions/required-action.actions';
import { setChallenges } from '../../store/actions/select-challenge.actions';
import { setIsAvailableSolutionSelected } from '../../store/actions/select-solution.action';
import {
  getAllRequiredCheckboxesSelected,
  getIsDesignApproved,
} from '../../store/selectors/required-action.selector';
import { selectPairChallenge } from '../../store/selectors/select-challenge.selectors';
import {
  getAvailableSolutions,
  selectIsAvailableSolutionSelected,
} from '../../store/selectors/select-solution.selectors';

@Injectable({
  providedIn: 'root',
})
export class StoreService {
  readonly #globalStore = inject(Store);

  getPairChallenge(): Observable<PairChallenge[]> {
    return this.#globalStore.select(selectPairChallenge);
  }

  getIsDesignApproved(): Observable<boolean> {
    return this.#globalStore.select(getIsDesignApproved);
  }

  getAvailableSolutions(): Observable<DiagnosisSolutionCompatibility[]> {
    return this.#globalStore.select(getAvailableSolutions);
  }

  getRequiredCheckboxSelected(): Observable<boolean> {
    return this.#globalStore.select(getAllRequiredCheckboxesSelected);
  }

  getSelectedSolution(): Observable<boolean> {
    return this.#globalStore.select(selectIsAvailableSolutionSelected);
  }

  dispatchSelectedSolution(isSelected: boolean): void {
    this.#globalStore.dispatch(
      setIsAvailableSolutionSelected({
        isSelectedSolutions: isSelected,
      }),
    );
  }

  dispatchRequiredCheckboxSelected(allChecked: boolean): void {
    this.#globalStore.dispatch(
      setAllRequiredCheckboxesSelected({
        areAllRequiredCheckboxesSelected: allChecked,
      }),
    );
  }

  dispatchPairChallenge(pairChallenges: PairChallenge[]): void {
    this.#globalStore.dispatch(
      setChallenges({
        pairChallenges,
      }),
    );
  }
}
